export default "__VITE_PUBLIC_ASSET__262e5f60__"